import type { ReactElement } from 'react';
import { cn } from '@/shared/ui';

interface StoreCategoryChipProps {
  readonly label: string;
  readonly isSelected: boolean;
  readonly onSelect: () => void;
}

/** 소분류 알약 한 칸 — 선택하면 검정 채움에 흰 글자, 아니면 얇은 테두리만. */
export const StoreCategoryChip = ({
  label,
  isSelected,
  onSelect,
}: StoreCategoryChipProps): ReactElement => (
  <li>
    <button
      type="button"
      aria-pressed={isSelected}
      onClick={onSelect}
      className={cn(
        'inline-flex h-9 cursor-pointer items-center rounded-full border px-4 text-sm whitespace-nowrap transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        isSelected
          ? 'border-foreground bg-foreground font-semibold text-background'
          : 'border-foreground/20 text-foreground/80 hover:border-foreground hover:text-foreground',
      )}
    >
      {label}
    </button>
  </li>
);
